module.exports = __webpack_public_path__ + "static/media/4.10.d966e043.png";